import { render, staticRenderFns } from "./OSSFileList.vue?vue&type=template&id=2486fdc0&scoped=true&"
import script from "./OSSFileList.vue?vue&type=script&lang=js&"
export * from "./OSSFileList.vue?vue&type=script&lang=js&"
import style0 from "./OSSFileList.vue?vue&type=style&index=0&id=2486fdc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486fdc0",
  null
  
)

export default component.exports